module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/redzel.2ab5a4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/redzel.jpg
// module id = iuSX
// module chunks = 0